import { ProductLineCodesTypes } from '../../business-lines/product-lines-codes';

export interface GetProjectDocumentsRequest {
  // required
  projectId: number;
  productLineCode: ProductLineCodesTypes;
}
